import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../../DataTable';
import Spinner from "../../Spinner";
import { toJS } from 'mobx';

@inject("reportingTemplateStore", "reportingTemplateHeaderStore", 'rolePermissionStore')
@observer
class ReportingTemplateList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  componentWillMount() {
    const { reportingTemplateStore, reportingTemplateHeaderStore } = this.props;
    if (!reportingTemplateHeaderStore.isLoading && !reportingTemplateHeaderStore.items.length) reportingTemplateHeaderStore.fetchItems();
    if (!reportingTemplateStore.isLoading && !reportingTemplateStore.items.length) reportingTemplateStore.fetchItems();
    if (!reportingTemplateStore.columnTypes.length) reportingTemplateStore.fetchColumnTypes()
  }

  handleDelete = (idOrIds) => {
    this.props.reportingTemplateStore.removeItems(idOrIds);
  }

  resource = 'data-delivery';
  slug = 'export/report/template';
  columns = [
    { key: 'id', label: 'ID', sortable: true, searchable: true },
    { key: 'name', label: 'Name', sortable: true, searchable: true },
    { key: 'description', label: 'Description', sortable: true, searchable: true },
  ];

  render() {
    const { reportingTemplateStore, rolePermissionStore, children } = this.props;
    const canModify = rolePermissionStore.validateRole(`modify ${this.resource}`);

    return (
      <div>
        <DataTable
          data={toJS(reportingTemplateStore.items)}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource={this.resource}
          actions={!canModify ? [
            { label: 'View', link: '/export/report/template/{id}' },
          ] : []}
        />
        {reportingTemplateStore.isLoading && <Spinner />}
        {children}
      </div>
    );
  }
}

export default ReportingTemplateList;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportingTemplateList.js